export const PATH_LIBRARY_FAVORITES = '/modules/library/favorites'
export const PATH_LIBRARY_PURCHASED = '/modules/library/purchased'

export const PATH_LIBRARY_FAVORITES_TV = `${PATH_LIBRARY_FAVORITES}/tv`
export const PATH_LIBRARY_FAVORITES_MOVIES = `${PATH_LIBRARY_FAVORITES}/movies`
export const PATH_LIBRARY_FAVORITES_SERIES = `${PATH_LIBRARY_FAVORITES}/shows`
export const PATH_LIBRARY_PURCHASED_TV = `${PATH_LIBRARY_PURCHASED}/tv`
export const PATH_LIBRARY_PURCHASED_MOVIES = `${PATH_LIBRARY_PURCHASED}/movies`
export const PATH_LIBRARY_PURCHASED_SERIES = `${PATH_LIBRARY_PURCHASED}/shows`
export const PATH_LIBRARY_PURCHASED_EVENTS = `${PATH_LIBRARY_PURCHASED}/events`
